export interface CookieOptionConfig {
  [key: string]: any,
}

export const setCookie = (name: string, value: any, options: CookieOptionConfig = {}): void => {
  const newOptions: CookieOptionConfig = {
    path: '/',
    ...options,
  };

  if (newOptions.expires instanceof Date) {
    newOptions.expires = newOptions.expires.toUTCString();
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  // eslint-disable-next-line guard-for-in
  for (const optionKey in newOptions) {
    updatedCookie += `; ${optionKey}`;
    const optionValue = newOptions[optionKey];
    if (optionValue !== true) {
      updatedCookie += `=${optionValue}`;
    }
  }
  document.cookie = updatedCookie;
};

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.pop()!.split(';')
    .shift();
};

export const deleteCookie = (name: string): void => {
  setCookie(name, '', {
    'max-age': -1,
  });
};
